import React from 'react';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import Store from '../../redux/store';
import Slide from '@material-ui/core/Slide';
import PinStepper from './Stepper';
import { IconClose } from '../../Icons';
import IconButton from '@material-ui/core/IconButton/IconButton';

function Transition(props) {
    return <Slide direction="down" {...props} />;
}

export default class NewPersonMd extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pname: '',
            city: ''
        };
    }

    componentDidMount() {
        this.persons = Store.getState().persons;
    }

    closeModal = () => {
        this.props.closeModal();
    };

    modalSuccess = () => {
        this.props.closeModal();
        this.props.onsuccess();
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                scroll="body"
                onClose={this.closeModal}
                keepMounted
                TransitionComponent={Transition}
            >
                <DialogContent>
                    <IconButton
                        onClick={this.closeModal}
                        style={{
                            position: 'absolute',
                            marginTop: -18,
                            right: 8,
                        }}
                        size="small"
                        color="secondary"
                    >
                        <IconClose style={{ fontSize: 20 }} />
                    </IconButton>

                    <PinStepper onsuccess={this.modalSuccess}/>
                </DialogContent>
            </Dialog>
        );
    }
}
